import type { ContentBlock } from '@lingoda/monolith-graphql';
import { Location } from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';

const parsePurchaseContentBlocks = (contentBlocks: readonly ContentBlock[]) => {
    let submitLabel: string | undefined;
    let testChargeLabel: string | undefined;
    const informationBanners: ContentBlock[] = [];
    const terms: ContentBlock[] = [];
    const warnings: ContentBlock[] = [];

    contentBlocks.forEach((contentBlock) => {
        switch (contentBlock.location) {
            case Location.Main:
                informationBanners.push(contentBlock);

                return;
            case Location.CheckoutButton:
                submitLabel = contentBlock.text;

                return;
            case Location.CheckoutTermsInformation:
                terms.push(contentBlock);

                return;
            case Location.CheckoutTestCharge:
                testChargeLabel = contentBlock.text;

                return;
            case Location.CheckoutWarnings:
                warnings.push(contentBlock);

                return;
        }
    });

    return {
        informationBanners,
        submitLabel: submitLabel || trans('btn-pay-now', {}, 'public-common'),
        terms,
        testChargeLabel,
        warnings,
    };
};

export default parsePurchaseContentBlocks;
